import React from 'react';
import RecordsProgressive from './records-progressive';

export default function WithdrawRecordsProgressive() {
  return <RecordsProgressive type="withdraw" />;
}
